import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    noindex?: boolean;
    suffix?: boolean;
}

const SEO: React.FC<SEOProps> = ({
    title,
    description,
    image = 'https://stillwatersacademy.com/og-image.png',
    url = 'https://stillwatersacademy.com',
    noindex = false,
    suffix = true
}) => {
    const siteName = "Still Waters Academy";
    let fullTitle = siteName;
    if (title) {
        if (!suffix || title.toLowerCase().includes(siteName.toLowerCase())) {
            fullTitle = title;
        } else {
            fullTitle = `${title} | ${siteName}`;
        }
    }
    const metaDescription = description || 'Still Waters Academy is an AI education platform offering 230+ conversational courses, K-12 homeschooling, elite masteries, university degree tracks, and white-label learning portals.';

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name="description" content={metaDescription} />
            <meta name="application-name" content="Still Waters Academy" />
            <meta name="format-detection" content="telephone=no" />
            {noindex && <meta name="robots" content="noindex, nofollow" />}
            {!noindex && <meta name="robots" content="index, follow" />}

            {/* Open Graph / Facebook */}
            <meta property="og:type" content="website" />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={metaDescription} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={url} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={metaDescription} />
            <meta name="twitter:image" content={image} />

            {/* Canonical Link */}
            <link rel="canonical" href={url} />
        </Helmet>
    );
};

export default SEO;
